export default __webpack_public_path__ + "static/media/Investing-rafiki.09856fe1.svg";